import store from '@carvana/purchase-store';
import * as Services from '../services';

export const LOAD_PLAID = 'PLAID/LOAD_PLAID';
export const LINK_PLAID = 'PLAID/LINK_PLAID';

export const LoadPlaid = callback =>
  store.dispatch({
    type: LOAD_PLAID,
    async payload() {
      return Services.loadPlaid(callback);
    }
  });

export const LinkPlaid = ({
  user,
  trackPlaidEvent = (_eventType, _data) => {},
  isBAV = false
}) =>
  store.dispatch({
    type: LINK_PLAID,
    async payload() {
      const plaidData = await Services.openPlaid({
        user,
        trackPlaidEvent,
        isBAV
      }).catch(() => ({}));

      const {
        publicToken,
        metadata: { account_id: accountId, accounts } = {}
      } = plaidData;

      const [{ verification_status: verificationStatus }] =
        accounts?.length > 0 ? accounts : [{}];

      if (accountId && publicToken) {
        return Promise.resolve({
          isValid: true,
          publicToken,
          accountId,
          verificationStatus
        });
      }

      return Promise.resolve({ isValid: false });
    }
  });
